import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { showErrorToast, showSuccessToast } from '../../utils/showToast';
import { url } from 'components/other/terms';

import { getDeviceId } from 'utils/deviceId';
import api from 'utils/axiosInterceptor';
import { setAccess } from './slice';
import { handleApiErrors } from 'utils/function';
axios.defaults.baseURL =url;
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const setAuthHeader = token => {

  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};

const clearAuthHeader = () => {
  axios.defaults.headers.common.Authorization = '';
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

export const register = createAsyncThunk(
  '/register',
  async (formData, thunkAPI) => {
    try {
      const deviceId = await getDeviceId();
      const dataWithDeviceId = { ...formData, deviceId };
      const response = await axios.post('/security/register', dataWithDeviceId);
      setAuthHeader(response.data.access.token);
      localStorage.setItem('accessToken', response.data.access.token); // ⬅️ Додай це
      localStorage.setItem('refreshToken', response.data.access.refreshToken);
      
      return response.data;
    } catch (error) {
      if (error.response) {
        const { message } = error.response.data;
 handleApiErrors(error.response.data,  showErrorToast);
        // showErrorToast(message);
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const valid = createAsyncThunk(
  '/validOneStep',
  async (formData, thunkAPI) => {
    try {
      const response = await axios.post('/security/validate-first-step', formData);
      return response.data;
    } catch (error) {

      // Перевірка наявності response
      if (error.response && error.response.data) {
        const { status, data } = error.response;
        console.log('status :>> ', data.details.email);
        // Перевірка наявності даних в error.response.data
        if (status === 422) {
          showErrorToast(data.details.email[0]);
        }

        console.log('error :>> ', error);
        return thunkAPI.rejectWithValue(error.response.data);
      }
    }
  }
);




export const logIn = createAsyncThunk(
  '/login',
  async (credentials, thunkAPI) => {
    try {
      const deviceId = await getDeviceId(); // отримуємо deviceId

      // додаємо deviceId у дані для логіну
      const dataWithDeviceId = { ...credentials, deviceId };


console.log('зайшли:>> ');
      const response = await axios.post('/security/merchant-login', dataWithDeviceId);

      setAuthHeader(response.data.access.token);
      localStorage.setItem('accessToken', response.data.access.token); // ⬅️ Додай це
      localStorage.setItem('refreshToken', response.data.access.refreshToken);
      

  
      return response.data;
    } catch (error) {
 
      if (error.response) {
        const { message } = error.response.data;
      
          showErrorToast(message);
        
     
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const logOut = createAsyncThunk('/logout', async (_, thunkAPI) => {
  try {
    await api.post('/security/logout');
  } catch (error) {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) showErrorToast('Not authorized.');
      if (status === 500) showErrorToast('Server error.');
    }
  } finally {
    clearAuthHeader();
  }
});

export const getCurrentUser = createAsyncThunk(
  '/current',
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
 
    const persistedToken = state.auth.access.token;

    if (persistedToken === null) {
      return thunkAPI.rejectWithValue('Unable to fetch user');
    }
    try {
      setAuthHeader(persistedToken);

      const response = await api.get('/account/info');
      return response.data;

    } catch (error) {
      if (error.response) {
        const { status } = error.response;
        if (status === 401) {
           logOut()
        }
        if (status === 500) {
          showErrorToast('Server error.');
        }
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);



export const getMerchantBill = createAsyncThunk(
  '/download-merchant-bill',
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const persistedToken = state.auth.access.token;

    if (!persistedToken) {
      return thunkAPI.rejectWithValue('Unable to fetch user');
    }

    try {
      setAuthHeader(persistedToken);

      // Додаємо налаштування для отримання даних у вигляді Blob
      const response = await api.get('/account/download-merchant-bill', {
        responseType: 'blob', // Вказуємо, що відповідь - це Blob
      });

      return response.data; // response.data містить Blob
    } catch (error) {
      if (error.response) {
        const { status } = error.response;
        if (status === 401) {
          showErrorToast('Not authorized.');
        }
        if (status === 500) {
          showErrorToast('Server error.');
        }
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
export const getPhone = createAsyncThunk(
  '/account/request-callback',
  async ({ id, phone }, thunkAPI) => {
    const state = thunkAPI.getState();
    const persistedToken = state.auth.access.token;

    if (!persistedToken) {
      return thunkAPI.rejectWithValue('Unable to fetch user');
    }

    try {
      setAuthHeader(persistedToken);

      // Виконання POST-запиту з передачею `id` та `phone` як параметрів
      const response = await api.post(`/account/request-callback`, null, {
        params: { phone },
      });

      return response.data; // response.data містить результат виконання
    } catch (error) {
      if (error.response) {
        const { status } = error.response;
        if (status === 422) {
          showErrorToast('Invalid phone number.');
        }
        if (status === 401) {
          showErrorToast('Not authorized.');
        }
        if (status === 500) {
          showErrorToast('Server error.');
        }
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateUser = createAsyncThunk(
  '/user',
  async (credentials, thunkAPI) => {
    try {
      const response = await api.post('/settings/merchant', credentials);
      return response.data.merchant ?response.data.merchant:response.data;
    } catch (error) {
      console.log('error :>> ', error);
            const details = error?.response?.data?.details;
      
            if (details) {
              // Перетворюємо всі ключі та масиви повідомлень у один спільний масив
              const messages = Object.values(details).flat();
      
              messages.forEach(msg => showErrorToast(msg));
            } else {
              showErrorToast(error?.data?.message || "Сталася помилка при оновленні даних користувача");
            }
   
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const updateUserLogo = createAsyncThunk(
  '/userLogo',
  async (credentials, thunkAPI) => {
    try {

      const response = await api.post('/settings/upload-logo', credentials);
      return response.data.logo;
    } catch (error) {
      showErrorToast(error.response.data.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);




export const updateUserBagPicture = createAsyncThunk(
  '/userBagPicture',
  async (credentials, thunkAPI) => {
    try {
      const response = await api.post('/settings/upload-bag-picture', credentials);
      return response.data.bag_picture;
    } catch (error) {
      showErrorToast(error.response.data.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);



export const deleteUserLogo = createAsyncThunk(
  '/deleteLogo',
  async (credentials, thunkAPI) => {
    try {
      await api.post('/settings/delete-logo', credentials);

    } catch (error) {
      // showErrorToast(error.response.data.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deleteUser = createAsyncThunk(
  '/deleteUser',
  async (_, thunkAPI) => {
    try {
      const response = await api.post('/settings/delete-account');

      showSuccessToast(response.data.message || 'Account successfully deleted');
      clearAuthHeader();
    
    } catch (error) {
      if (error.response) {
        showErrorToast(error.response.data.message);
        return thunkAPI.rejectWithValue(error.response.data);
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);



export const deleteUserBagPicture = createAsyncThunk(
  '/deleteBagPicture',
  async (credentials, thunkAPI) => {
    try {
      await api.post('/settings/delete-bag-picture', credentials);

    } catch (error) {
      // showErrorToast(error.response.data.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);






export const sendVerifyEmailUser = createAsyncThunk(
  '/resendVerifyEmail',
  async (credentials, thunkAPI) => {
    try {
      console.log('credentials :>> ', credentials);
      const response = await api.post('/security/confirm-email', credentials);
      showSuccessToast(
        response.message
      );

      return credentials;
    } catch (error) {
      showErrorToast(error.response.data.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getVerifyEmailUser = createAsyncThunk(
  '/getVerifyEmail',
  async (verifyToken, thunkAPI) => {
    try {
      const response = await axios.get(`/verify/${verifyToken}`);

      return response.data.verify;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const recoveryRequest = createAsyncThunk(
  '/recovery-request',
  async (email, thunkAPI) => {
    try {
      const response = await axios.post('/security/recovery-request', email);
      console.log('response :>> ', response);
      // showSuccessToast(
      //   'The new password has been successfully sent to your email'
      // );
      return;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const changePassword = createAsyncThunk(
  '/changePassword',
  async (data, thunkAPI) => {
    try {
      await api.post('/changePassword', data);
      showSuccessToast('Your password has been successfully updated');
      return;
    } catch (error) {
      showErrorToast('You have entered an invalid old password');
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);


export const finalOnBoard = createAsyncThunk(
  '/finalOnBoard',
  async (_, thunkAPI) => {
    await api.post('/settings/disable-onboarding');
    getCurrentUser();
    return false;


  }
);


export const renewPassword = createAsyncThunk(
  '/renewPassword',
  async (data, thunkAPI) => {
    try {
      const response = await api.post('/security/recovery', data);

      showSuccessToast('Your password has been successfully updated');
      return response;
    } catch (error) {
      showErrorToast('You have entered an invalid old password');
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);


// використовуємо вже існуючий logOut

export const refreshTokenThunk = createAsyncThunk(
  'auth/refreshToken',
  async (_, { getState, dispatch, rejectWithValue }) => {
    try {
      const { token, refreshToken } = getState()?.auth?.access;
      const deviceId = await getDeviceId();
      // const refreshToken = localStorage.getItem('refreshToken');
      console.log('objectDM :>> ', refreshToken);
      const response = await axios.post('/security/refresh-token', {
        jwt: token,
        refreshToken,
        deviceId: deviceId
      });

      setAuthHeader(response?.data?.access?.token);
      localStorage.setItem('refreshToken', response?.data?.access?.refreshToken);
      dispatch(setAccess(response?.data?.access));
      dispatch(setAccess(response?.data?.access));
      localStorage.setItem('accessToken', response?.data?.access?.token); // ⬅️ Додано
      localStorage.setItem('refreshToken', response?.data?.access?.refreshToken);
      
      console.log('refresh payload', response?.data);
      return response?.data;
    } catch (error) {
      const status = error?.response?.status;

      // // ❗ Якщо токен протермінований або refreshToken невалідний — робимо logOut
      // if (status === 401 || status === 403) {
      //   await dispatch(logOut()); // очищає Redux + заголовки
      //   localStorage.removeItem('refreshToken');
      //   showErrorToast('Сесія завершена. Авторизуйтеся знову.');
      // }

      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);


export const updatePassword = createAsyncThunk(
  '/updatePassword',
  async ({ old_password, password }, thunkAPI) => {
    try {
      const deviceId = await getDeviceId();
      const payload = { old_password, password, deviceId };

      const response = await api.post('/settings/change-password', payload);

      // showSuccessToast(response.data.message || 'Password successfully changed');

      localStorage.setItem('accessToken', response?.data?.access?.token); // ⬅️ Додано
      localStorage.setItem('refreshToken', response?.data?.access?.refreshToken);
      return response.data;

  
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 422 && data.details?.length) {
          showErrorToast(data.details[0]);
        } else {
          showErrorToast(data.message || 'Failed to change password');
        }
        return thunkAPI.rejectWithValue(data);
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);